import { useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useI18n } from '@runtime/core/i18n/i18n'
import { useAppStore } from '@runtime/core/store/appStore'
import { usePlayShare } from '@/features/sharing/usePlayShare'
import { readHomeSelection } from './arrival/homeArrival'
import { useHomePosterSelection } from './arrival/useHomePosterSelection'
import HomePlay from './components/HomePlay'
import HomeSignature from './components/HomeSignature'
import HomeResources from './components/HomeResources'
import HomeActions from './components/HomeActions'
import HomeFooter from './components/HomeFooter'
import HomeToast from './components/HomeToast'
import styles from './HomeRoute.module.scss'

export default function HomeRoute() {
  const { t } = useI18n()
  const location = useLocation()
  const scanned = useRef(Boolean(readHomeSelection(location.search)))
  const { state, clearRequest, useOriginal, retry } = useHomePosterSelection()
  const themeRev = useAppStore(s => s.themeRev)
  const setPosterOpen = useAppStore(s => s.setPosterOpen)
  const { share: handleShare, toast } = usePlayShare()
  return (
    <main
      className={styles.home}
      data-testid="poster-home-page"
      data-theme-rev={themeRev}
      data-theme-id={state.status === 'ready' ? state.cfg.id : undefined}
    >
      <HomeToast toast={toast} />
      <header className={styles.intro}>
        <HomeSignature />
        <h1>{t('home.title')}</h1>
        <p>{t('home.welcome.intro')}</p>
      </header>
      <HomePlay
        state={state}
        scanned={scanned.current}
        onChoose={() => {
          clearRequest()
          setPosterOpen(true)
        }}
        onOriginal={useOriginal}
        onRetry={retry}
      />
      <HomeResources />
      <HomeActions onShare={handleShare} />
      <HomeFooter />
    </main>
  )
}
